import * as yup from 'yup';

const accessRuleFormSchema = yup.object().shape({
  name: yup.string().required('accessRuleNameRequired'),
  timeProfile: yup.mixed().required('timeProfileRequired'),
  zone: yup.mixed().required('resourcesRequired'),
  group: yup.mixed().required('groupRequired'),
});

export default accessRuleFormSchema;

